import type { IDropDownItem } from "@similarweb/ui-components";
import { Dropdown } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import {
    StyledDropdownParent,
    StyledSingleSelectDDItem,
    StyledSingleSelectDDItemText,
} from "app/pages/sales-intelligence/common-components/dropdown/styles";
import useDelayedAction from "app/pages/sales-intelligence/hooks/useDelayedAction";
import useUncontrolledDropdown from "app/pages/sales-intelligence/hooks/useUncontrolledDropdown";
import FilterButtonLabel from "app/pages/sales-intelligence/sub-modules/signals/components/filters/shared/FilterDropdown/FilterButtonLabel/FilterButtonLabel";
import SignalFilterDropdownButton from "app/pages/sales-intelligence/sub-modules/signals/components/filters/shared/FilterDropdown/SignalFilterDropdownButton/SignalFilterDropdownButton";
import { DROPDOWN_AUTO_OPEN_DELAY } from "app/pages/sales-intelligence/sub-modules/signals/constants/dropdown";
import { buildDropdownSelectedItemsFromArray } from "app/pages/sales-intelligence/utils/dropdowns";

type DropdownItem = Omit<IDropDownItem, "id"> & {
    id: string;
};

type Props = {
    selectedValue: string | undefined;
    options: readonly string[];
    autoOpen?: boolean;
    onValueChange(value: string): void;
};

const SignalEcommerceBucketFilter = ({ selectedValue, options, autoOpen = false, onValueChange }: Props) => {
    const selectedItems: Record<string, boolean> = buildDropdownSelectedItemsFromArray(
        selectedValue ? [selectedValue] : [],
    );

    const { dropdownRef, onUncontrolledOpen } = useUncontrolledDropdown();

    useDelayedAction(DROPDOWN_AUTO_OPEN_DELAY, onUncontrolledOpen, autoOpen);

    const handleClick = (item: DropdownItem): void => {
        onValueChange(item.id);
    };

    return (
        <StyledDropdownParent id="ecommerce-bucket-dd">
            <Dropdown
                ref={dropdownRef}
                appendTo="#ecommerce-bucket-dd"
                selectedIds={selectedItems}
                width={200}
                dropdownPopupHeight={190}
                onClick={handleClick}
            >
                <SignalFilterDropdownButton
                    id="ecommerce-bucket"
                    hasValue={typeof selectedValue !== "undefined"}
                >
                    <FilterButtonLabel>
                        {selectedValue ?? translate("si.signals.ecommerce.filters.bucket.placeholder")}
                    </FilterButtonLabel>
                </SignalFilterDropdownButton>

                {...options.map((option) => (
                    <StyledSingleSelectDDItem
                        data-automation={`ecommerce-bucket-dd-item-${option}`}
                        id={option}
                        key={option}
                    >
                        <StyledSingleSelectDDItemText>{option}</StyledSingleSelectDDItemText>
                    </StyledSingleSelectDDItem>
                ))}
            </Dropdown>
        </StyledDropdownParent>
    );
};

export default SignalEcommerceBucketFilter;
